import React from "react";
import { Pill } from "../shared/Pill";

export function QuestionCard({ tag, question, subtitle, children, footer }) {
    return (
        <section
            className="relative max-w-3xl mx-auto px-5 md:px-0 py-10 animate-fade-up"
            data-testid="question-card"
        >
            <div className="mb-6">
                <Pill tone="teal" className="mb-5">
                    {tag}
                </Pill>
                <h2 className="text-2xl md:text-[34px] leading-tight font-semibold tracking-tight text-klareet-TEXT">
                    {question}
                </h2>
                {subtitle ? (
                    <p className="mt-3 text-base text-klareet-MUT max-w-[55ch]">
                        {subtitle}
                    </p>
                ) : null}
            </div>
            <div>{children}</div>
            {footer ? <div className="mt-8">{footer}</div> : null}
        </section>
    );
}
